<template>
  <!-- 上传附件，并以表格样式展示 -->
  <div>
    <div style="margin-bottom: 20px">
      <div style="float: left">
        <UploadBtn
          label="上传附件"
          :fileType="fileType"
          :sameValid="false"
          :fileWaitTime="120000"
          :fileMaxSize="12 * 1024 * 1024"
          @change="addFile"
        ></UploadBtn>
      </div>
      <div style="line-height: 30px; margin-left: 20px">{{ tips }}</div>
    </div>
    <avue-crud :option="tableOption" :data="fileList" ref="crud">
      <template slot="operate" slot-scope="{ row }">
        <i class="el-icon-delete" style="cursor: pointer;" @click="delFile(row)"></i>&nbsp;<i
          v-if="needDownload"
          class="el-icon-download"
          style="cursor: pointer;"
          @click="downloadAttach(row)"
        ></i>
      </template>
      <template slot="extension" slot-scope="{ row }">
        <i
          v-if="['.png', '.jpg', '.jpeg'].includes(row.extension)"
          class="el-icon-picture-outline"
        ></i>
        <i
          v-else-if="['.xlx', '.xlsx', '.doc', '.docx', '.ppt', '.pptx'].includes(row.extension)"
          class="el-icon-document"
        ></i>
        <i v-else class="el-icon-folder"></i>
      </template>
      <template slot="createUser">
        <span>{{ userInfo.nick_name }}</span>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UploadBtn from '@/views/mp-style/upload-btn';
import { downloadFile } from '@/api/crmedical/contract/add';

export default {
  name: 'UploadTable',
  components: {
    UploadBtn,
  },
  props: {
    // 附件列表
    fileList: {
      type: Array,
      default: () => [],
    },
    // 附件个数限制，不传或者传0表示无限制
    fileMaxNum: {
      type: Number,
      default: 0,
    },
    // 单个附件的大小限制，0表示无限制
    fileMaxSize: {
      type: Number,
      default: 0,
    },
    // 支持上传的附件类型
    fileType: {
      type: String,
      default: 'image/*,video/*,audio/*,.xlx,.xlsx,.doc,.docx,.ppt,.pptx',
    },
    // 辅助提示语
    tips: {
      type: String,
      default: '',
    },
    // 是否需要下载功能
    needDownload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        index: true,
        border: true,
        dialogClickModal: false,
        refreshBtn: false,
        columnBtn: false,
        addBtn: false,
        menu: false,
        column: [
          {
            label: '操作',
            prop: 'operate',
            slot: true,
          },
          {
            label: '缩略图',
            prop: 'extension',
            slot: true,
          },
          {
            label: '附件名称',
            prop: 'originalName',
          },
          {
            label: '上传时间',
            prop: 'createTime',
          },
          {
            label: '上传人',
            prop: 'createUser',
            slot: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    update() {
      this.$emit('update', this.fileList);
    },
    addFile(file) {
      if (this.fileMaxNum && this.fileList.length >= this.fileMaxNum) {
        this.$message.error(`最多只可上传${this.fileMaxNum}个附件`);
        return;
      }
      this.fileList.push(file);
      this.update();
    },
    delFile(file) {
      let deleteIndex = -1;
      for (let i = 0, len = this.fileList.length; i < len; i++) {
        if (this.fileList[i] == file) {
          deleteIndex = i;
          break;
        }
      }
      if (deleteIndex !== -1) {
        this.fileList.splice(deleteIndex, 1);
        this.update();
      }
    },
    /* 下载附件 */
    downloadAttach(row) {
      downloadFile(row.link, row.originalName);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
/* 图标大小 */
i[class^='el-icon'] {
  font-size: 20px;
}
</style>
